import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=10be5e84&scoped=true&"
import script from "./Beneficiaries.vue?vue&type=script&lang=js&"
export * from "./Beneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be5e84",
  null
  
)

export default component.exports